import React from 'react'
import { Heart, Shield, AlertTriangle } from 'lucide-react'
import './Footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Heart className="footer-icon" />
              <span>Gender Genie</span>
            </div>
            <p className="footer-description">
              AI-powered gender prediction using nub theory analysis for entertainment purposes.
            </p>
          </div>

          <div className="footer-section">
            <h4>Important Information</h4>
            <div className="info-item">
              <Shield size={16} />
              <span>Your privacy is protected - images are not stored</span>
            </div>
            <div className="info-item">
              <AlertTriangle size={16} />
              <span>For entertainment only - consult healthcare providers for medical advice</span>
            </div>
          </div>

          <div className="footer-section">
            <h4>How It Works</h4>
            <ul className="footer-list">
              <li>Upload your 12-15 week ultrasound scan</li>
              <li>AI analyzes the genital tubercle angle</li>
              <li>Prediction based on nub theory principles</li>
              <li>Results for entertainment purposes only</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Gender Genie. Made with ❤️ for expecting parents.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
